import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { AttachmentView } from '../../attachment-view.model';

@Component({
  selector: 'app-attachments-uploading-list',
  templateUrl: './attachments-uploading-list.component.html',
  styleUrls: ['./attachments-uploading-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsUploadingListComponent implements OnInit {
  @Input() attachmentsInProgress: List<AttachmentView>;

  @Output()
  onCancelAttachment: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();
  @Output()
  onRetryAttachment: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();

  constructor() {}

  ngOnInit() {}

  trackByAttachmentProgress(index, attachmentView: AttachmentView) {
    return attachmentView.id;
  }
}
